import { FormattedBookingTypeData } from '../../../../models/property-details-page/booking-type-model'
import isInquiryButtonVisible from './is-inquiry-button-visible'
import is24HourBookingButtonVisible from './is-24-hour-booking-button-visible'
import isDirectBookingButtonVisible from './is-direct-booking-button-visible'

const isCallButtonVisible = ({ bookingType }: { bookingType: FormattedBookingTypeData | null }): boolean => {
    if (!bookingType) {
        return false
    }
    return (
        isInquiryButtonVisible({ bookingType }) &&
        !is24HourBookingButtonVisible({ bookingType }) &&
        !isDirectBookingButtonVisible({ bookingType })
    )
}

export default isCallButtonVisible
